import { render, staticRenderFns } from "./SingleUser.vue?vue&type=template&id=5f20f9a4&"
import script from "./SingleUser.vue?vue&type=script&lang=js&"
export * from "./SingleUser.vue?vue&type=script&lang=js&"
import style0 from "./SingleUser.vue?vue&type=style&index=0&id=5f20f9a4&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports